-- Records are tables with declared fields, built with `new`. An interface is a shape,
-- and it may implement what it declares — an implementor inherits the behaviour rather
-- than a copy of it.

local interface Greeter
    name: string

    function greet(self): string
        return "hello, " .. self.name
    end
end

local record Person is Greeter
    name: string
    age: integer

    function isAdult(self): boolean
        return self.age >= 18
    end
end

local record Robot is Greeter
    name: string

    @override
    function greet(self): string
        return "BEEP. " .. self.name .. " ONLINE."
    end
end

local ada = new Person(name = "ada", age = 36)
local unit = new Robot(name = "unit-7")

local crew: {Greeter} = {ada, unit}
for _, member in ipairs(crew) do
    print(member:greet())
end

print(ada.name, ada:isAdult())

-- try breaking it: drop Robot's `@override`, or ask a Greeter for something only a
-- Person has
